import {getWallet} from '../../helpers/wallet';
import {addPending} from './addPending';
import {SET_LOADING} from '../../types';
import { sendTx } from '../../helpers/bc';
import { getNRGBalance, getSpendableOutpoints } from '../../passport/get';

import {
  createNRGTransferTransaction
} from 'bc-sdk/dist/transaction'

export function payNRG({password,amount,to,fee},done){
  return async function(dispatch,getState){
    try {
      if (!fee) {
        fee = 0
      }
      dispatch({type:SET_LOADING,payload:true})
      let state = getState()

      let { privateKey: bcPrivateKeyHex, address: bcAddress } = getWallet(getState, 'nrg', password)

      const spendableOutpointsList = getState().passport.spendableOutpoints
      const tx = createNRGTransferTransaction(
        spendableOutpointsList,
        bcAddress.toLowerCase(),
        bcPrivateKeyHex,
        to,
        amount.toString(),
        fee.toString()
      )
      let data = await sendTx(state.settings.settings, tx)
      if(data.txHash){
        getNRGBalance(dispatch, state)
        getSpendableOutpoints(dispatch, state)
        addPending(dispatch,state,{hash:data.txHash,chain:'NRG',to,from:bcAddress,amount})
        dispatch({type:SET_LOADING,payload:false})
        done(null,data)
      }
      else {
        console.log({data})
        dispatch({type:SET_LOADING,payload:false})
        done('Could not transfer NRG')
      }
    }
    catch(err){
      console.log({err})
      dispatch({type:SET_LOADING,payload:false})
      done(err);
    };
  }
}
